module.exports = __webpack_public_path__ + "static/house-3-e2b7e4f26befde8083e0c33f002c8c5e.png";